/**
 * Created by karora on 11/10/19.
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { IssueCount } from '../types/issue-count';

@Component({
  selector: 'dash-issues',
  template: `<div class="active-issues">
  <div *ngFor="let issue of issueCount" class="issue-counts"
      [style.background-color]="this.getIssueColor(issue)"
      (click)="gotoIssues(issue.status)"> 
  <span class="version-group">{{issue.issue_status_text}}</span>
  <span class="group-count">{{issue.num_issues}}</span>
  </div>
</div>
`,
  styles: [
    `.active-issues { display: block; width: 100%; }`,
    `.issue-counts {
      display: inline-block;
      width: 10em;
      margin: 0 0.5em 0.5em 0.5em;
      padding: 0.1em 0.5em;
      color: #202020;
    }`,`
    .version-group {
      display: inline-block;
      width: 7em;
      line-height: 3em;
      vertical-align: middle;
    }`,`
    .group-count {
      display: inline-block;
      width: 2em;
      line-height: 3em;
      vertical-align: middle;
      text-align: right;
    }`
  ],
})

export class DashIssueComponent implements OnInit {
  issueCount: IssueCount[] = [];
  errorMessage: string;

  constructor(
    private hubService: HubService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.hubService.getIssueCounts().subscribe(
      issueCount => this.issueCount = issueCount,
      error => this.errorMessage = <any>error,
    );
  }

  gotoIssues(status: number): void {
    this.router.navigate(['/issues', { 'status': status }]);
  }

  getIssueColor(issue: IssueCount): string {
    switch (issue.status) {
      case 1:
        return '#e88080';
      case 2:
        return '#f0b0b0';
      case 3:
        return '#80f08e';
      case 4:
        return '#f0d0d0';
      case 5:
        return '#f0d0d0';
      default:
        return '#f8c0c0';
    }
  }

}
